import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { GovtManageSchemesComponent } from '../govt-manage-schemes/govt-manage-schemes.component';

@Component({
  selector: 'app-govt-schemes',
  templateUrl: './govt-schemes.component.html',
  styleUrls: ['./govt-schemes.component.scss'],
  providers: [DatePipe],
})
export class GovtSchemeComponent implements OnInit {
  displayedColumns = [
    'schemtTitle',
    'datePosted',
    'categoryName',
    'attachLink',
  ];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectedIndex = -1;
  form: FormGroup;
  response;
  categorydatalist;
  categorydata;
  Datepublished: Date;
  myDateValue: Date;
  today: Date = new Date();
  govtschemedatalist;
  govtschemedata;
  size = 2;
  pageIndex = 0;
  buttondisable = false;
  reg =
    '^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$';

  isButtonVisible = false;
  lastFilePath: any;
  submitted: boolean;

  constructor(
    private datepipe: DatePipe,
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.selectedIndex = 2;

    this.form = this.fb.group({
      //SchemtTitle: ['', [ Validators.pattern("([a-zA-Z0-9',._.!#$%&+/=?^@_`{|}~-]+( [a-zA-Z0-9',._-]+)*){2,150}")]], //mandatory include document Attchment
      SchemtTitle: [
        '',
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
      DatePosted: [],
      Description: [
        '',
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ], //500 character (optional)
      CategoryID: ['', [Validators.required]], //mandatory
      Attachedlink: ['', [Validators.pattern(this.reg)]],
      Remark: [''],
    });

    this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    this._userService.getCategorylist().subscribe((data) => {
      this.categorydata = data;
      this.categorydatalist = this.categorydata.result.data;
    });

    var categoryReq = {
      id: 'f16d74f5-35f8-481f-ae52-288231d24621',
      pageNumber: 0,
    };
    this._userService
      .getGovtSchemeCategorylist(categoryReq)
      .subscribe((data) => {
        this.govtschemedata = data;
        this.govtschemedatalist = this.govtschemedata.result.data.list;
        this.dataSource = new MatTableDataSource(this.govtschemedatalist);
        this.dataSource.paginator = this.paginator;
      });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  showViews(index: number) {
    this.selectedIndex = index;
  }

  categoryId;
  getcategoryId(id) {
    this.categoryId = id;
  }

  imageSrc;
  FileUploadFile: any;
  //base64s
  FileUploadString: string;
  //json
  finalJson = {};
  currentId: number = 0;

  log() {
    // for debug
  }

  getcategoryforFilter(categoryId) {
    var categoryReq = {
      id: categoryId,
      pageNumber: 0,
    };
    this._userService
      .getGovtSchemeCategorylist(categoryReq)
      .subscribe((data) => {
        this.govtschemedata = data;
        this.govtschemedatalist = this.govtschemedata.result.data.list;
        this.dataSource = new MatTableDataSource(this.govtschemedatalist);
        this.dataSource.paginator = this.paginator;
      });
  }

  fileData;
  finaldata;

  file1: File;
  //file2 : File;
  @ViewChild('inputFile') myInputVariable: ElementRef;
  processImage(event) {
    this.isButtonVisible = true;
    // let files: FileList = event.target.files;
    // this.file1  = files[0];
    let splitfile = event.target.files[0].type;
    let type = splitfile.split('/');

    if (
      type[1] == 'jpeg' ||
      type[1] == 'jpg' ||
      type[1] == 'png' ||
      type[1] == 'pdf'
    ) {
      this.finaldata = this.file1;
      //this.file2 = this.file1;
      this.savescheme = true;
    } else {
      // if(this.file2 != null){
      //   this.finaldata = this.file2;
      //   this.savescheme = true;
      //   return;
      // }

      this.finaldata = 0;
      this.myInputVariable.nativeElement.value = '';
      this.savescheme = false;
      this.isButtonVisible = false;
      this.toastr.warning(
        'Accepted File Formats PDF,PNG.JPG and JPEG only',
        'Info',
        {
          timeOut: 3000,
        }
      );
      //this.file2 = null;
      return;
    }

    this.lastFilePath = this.myInputVariable.nativeElement.value;
    let files: FileList = event.target.files;
    this.file1 = files[0];

    if (this.file1.size >= 1572864) {
      this.myInputVariable.nativeElement.value = '';
      this.toastr.warning('Accepted File Size should be below 5MB', 'Info', {
        timeOut: 3000,
      });
    } else {
      this.finaldata = this.file1;
      this.savescheme = true;
    }
  }

  savescheme = false;
  // descriptionchange(data) {
  //   if (data.length != 0) {
  //     this.savescheme = true
  //   }
  //   else {
  //     this.savescheme = false
  //   }
  // }

  get attach_url() {
    return this.form.get('Attachedlink');
  }

  onSubmit() {
    if (this.form.value.Attachedlink != '') {
      var pattern = new RegExp(this.reg);
      var result = pattern.test(this.form.value.Attachedlink);
      if (result == false) {
        alert('Please enter valid attachedlink.');
        return false;
      }
    }
    this.spinner.show();
    var datepublished = this.datepipe.transform(this.today, 'dd-MM-yyyy');

    let myfile = this.finaldata;
    if (this.form.status == 'INVALID') {
      alert('Please fill all mandatory fields and enter valid values');
    } else {
      const postdata = new FormData();
      postdata.append('SchemtTitle', this.form.value.SchemtTitle);

      // if(this.savescheme == false){
      //   this.toastr.error("Please Give Description or Please upload File For Govt Scheme Update", 'Error', {
      //     timeOut: 3000,
      //   });
      // }
      if (
        this.categoryId == undefined ||
        this.form.value.SchemtTitle == '' ||
        this.form.value.Description == ''
      ) {
        alert('Please Enter Mandatory fields');
      } else {
        let text = confirm(
          'Are you sure you want to publish this govt scheme ?'
        );
        if (text == true) {
          // postdata.append('DatePosted', datepublished);
          postdata.append('Description', this.form.value.Description);
          postdata.append('CategoryID', this.categoryId);
          postdata.append('AttachLink', this.form.value.Attachedlink);
          postdata.append('AttachedFileUpload', this.finaldata);
          postdata.append('CategoryName', '');
          postdata.append('DatePosted', '');
          postdata.append('AttachedFile', '');
          postdata.append('Remark', this.form.value.Remark);
          postdata.append('GovSchemeID', '');

          this._userService.postGovtScheme(postdata).subscribe((data) => {
            this.response = data;
            this.spinner.hide();
            // var message:any = response.result.data
            // alert(message.message);
            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
          });
          this.router
            .navigateByUrl('', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/Govt-schemes']);
            });
        } else {
          //  return false;
        }
      }
    }
    this.spinner.hide();
  }

  listPage() {
    this.router.navigate(['/Govt-schemes-list']);
  }

  removeFile() {
    this.isButtonVisible = false;
    this.myInputVariable.nativeElement.value = '';
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    this.dialog.open(GovtManageSchemesComponent, dialogConfig);
  }
}

export interface PeriodicElement {
  position: number;
  SchemeName: string;
  Description: string;
  Category: string;
  DatePublished: string;
  AttachedDocument: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {
    position: 1,
    SchemeName: 'SchemeName1',
    Description: 'Description1',
    Category: 'Category1',
    DatePublished: '23/09/2021',
    AttachedDocument: 'Document1',
  },
  {
    position: 2,
    SchemeName: 'SchemeName2',
    Description: 'Description2',
    Category: 'Category2',
    DatePublished: '23/09/2021',
    AttachedDocument: 'Document1',
  },
  {
    position: 3,
    SchemeName: 'SchemeName3',
    Description: 'Description3',
    Category: 'Category3',
    DatePublished: '23/09/2021',
    AttachedDocument: 'Document1',
  },
  {
    position: 4,
    SchemeName: 'SchemeName4',
    Description: 'Description4',
    Category: 'Category4',
    DatePublished: '23/09/2021',
    AttachedDocument: 'Document1',
  },
  {
    position: 5,
    SchemeName: 'SchemeName5',
    Description: 'Description5',
    Category: 'Category5',
    DatePublished: '23/09/2021',
    AttachedDocument: 'Document1',
  },
];
